if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

// High-priority global cart addition network interceptor (No setTimeout)
(function() {
  let lastClickedButton = null;

  function getActiveAtcButton() {
    return lastClickedButton
      || document.querySelector('.product-form__submit.loading, .mobile-sticky-atc__button.loading, .button-add-to-cart.loading') 
      || document.querySelector('.product-form__submit, .mobile-sticky-atc__button, .button-add-to-cart');
  }

  function startLoading(clickedButton) {
    if (clickedButton) lastClickedButton = clickedButton;
    const button = getActiveAtcButton();
    if (button) {
      const spinner = button.querySelector('.loading__spinner');
      button.classList.add('loading');
      button.setAttribute('aria-disabled', 'true');
      if (spinner) spinner.classList.remove('hidden');
    }
  }

  function stopLoading() {
    lastClickedButton = null;
    const buttons = document.querySelectorAll('.product-form__submit, .mobile-sticky-atc__button, .button-add-to-cart');
    buttons.forEach(button => {
      const spinner = button.querySelector('.loading__spinner');
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
      if (spinner) spinner.classList.add('hidden');
    });
  }

  // Hook into Click first to handle instant feedback
  document.addEventListener('click', function(event) {
    const button = event.target.closest('.product-form__submit, .mobile-sticky-atc__button, .button-add-to-cart');
    if (button && !button.disabled && button.getAttribute('aria-disabled') !== 'true') {
      startLoading(button);
    }
  }, { capture: true });

  // Hook into window.fetch to know when cart add finishes
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0];
    const isCartAdd = typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/update'));
    
    if (isCartAdd) {
      startLoading();
    }
    
    return originalFetch.apply(this, args)
      .then(response => {
        if (isCartAdd) stopLoading();
        return response;
      })
      .catch(error => {
        if (isCartAdd) stopLoading();
        throw error;
      });
  };

  // Hook into XMLHttpRequest to know when cart add finishes (Gokwik or others might use XHR)
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    return originalOpen.apply(this, arguments);
  };

  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function() {
    const isCartAdd = typeof this._url === 'string' && (this._url.includes('/cart/add') || this._url.includes('/cart/update'));
    
    if (isCartAdd) {
      startLoading();
      this.addEventListener('loadend', stopLoading);
    }
    
    return originalSend.apply(this, arguments);
  };
})();
